export const EMPTY_SYMBOL_PLACEHOLDER = 'NEW';
